(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fluentui/react"));
	else if(typeof define === 'function' && define.amd)
		define(["@fluentui/react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@fluentui/react")) : factory(root["@fluentui/react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__49__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ComponentSettings: true,
  ThemeFluentComponentSettings: true,
  Constants: true
};
exports.Constants = exports.ThemeFluentComponentSettings = exports.ComponentSettings = void 0;

var ComponentSettings = _interopRequireWildcard(__webpack_require__(2));

exports.ComponentSettings = ComponentSettings;
exports.ThemeFluentComponentSettings = ComponentSettings;

var Constants = _interopRequireWildcard(__webpack_require__(27));

exports.Constants = Constants;

var _index2 = __webpack_require__(47);

Object.keys(_index2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index2[key];
    }
  });
});

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alertStyle", {
  enumerable: true,
  get: function get() {
    return _alertStyle.alertStyle;
  }
});
Object.defineProperty(exports, "buttonInputStyle", {
  enumerable: true,
  get: function get() {
    return _buttonInputStyle.buttonInputStyle;
  }
});
Object.defineProperty(exports, "btnStyle", {
  enumerable: true,
  get: function get() {
    return _buttonStyle.btnStyle;
  }
});
Object.defineProperty(exports, "btnInteractStyle", {
  enumerable: true,
  get: function get() {
    return _buttonStyle.btnInteractStyle;
  }
});
Object.defineProperty(exports, "closeImageStyle", {
  enumerable: true,
  get: function get() {
    return _closeImageStyle.closeImageStyle;
  }
});
Object.defineProperty(exports, "controlStyle", {
  enumerable: true,
  get: function get() {
    return _control.controlStyle;
  }
});
Object.defineProperty(exports, "datePickerStyle", {
  enumerable: true,
  get: function get() {
    return _datePickerStyle.datePickerStyle;
  }
});
Object.defineProperty(exports, "dropDownEditorStyle", {
  enumerable: true,
  get: function get() {
    return _dropDownEditorStyle.dropDownEditorStyle;
  }
});
Object.defineProperty(exports, "fabricPanelStyle", {
  enumerable: true,
  get: function get() {
    return _fabricPanelStyle.fabricPanelStyle;
  }
});
Object.defineProperty(exports, "floatButtonStyle", {
  enumerable: true,
  get: function get() {
    return _floatButtonStyle.floatButtonStyle;
  }
});
Object.defineProperty(exports, "gridInlineErrorStyle", {
  enumerable: true,
  get: function get() {
    return _gridInlineErrorStyle.gridInlineErrorStyle;
  }
});
Object.defineProperty(exports, "helpbuttonStyle", {
  enumerable: true,
  get: function get() {
    return _helpButtonStyle.helpbuttonStyle;
  }
});
Object.defineProperty(exports, "InlineEditorStyle", {
  enumerable: true,
  get: function get() {
    return _inlineEditorStyle.InlineEditorStyle;
  }
});
Object.defineProperty(exports, "inlineErrorStyle", {
  enumerable: true,
  get: function get() {
    return _inlineErrorStyle.inlineErrorStyle;
  }
});
Object.defineProperty(exports, "scrollbarStyle", {
  enumerable: true,
  get: function get() {
    return _scrollbarStyle.scrollbarStyle;
  }
});
Object.defineProperty(exports, "searchboxStyle", {
  enumerable: true,
  get: function get() {
    return _searchBoxStyle.searchboxStyle;
  }
});
Object.defineProperty(exports, "SearchBox", {
  enumerable: true,
  get: function get() {
    return _searchBox.SearchBox;
  }
});
Object.defineProperty(exports, "entitySelectorStyle", {
  enumerable: true,
  get: function get() {
    return _entitySelectorStyle.entitySelectorStyle;
  }
});
Object.defineProperty(exports, "paginationStyle", {
  enumerable: true,
  get: function get() {
    return _paginationStyle.paginationStyle;
  }
});
Object.defineProperty(exports, "statusStyle", {
  enumerable: true,
  get: function get() {
    return _statusStyle.statusStyle;
  }
});
Object.defineProperty(exports, "toggleButtonStyle", {
  enumerable: true,
  get: function get() {
    return _toggleButtonStyle.toggleButtonStyle;
  }
});
Object.defineProperty(exports, "underlineLinkStyle", {
  enumerable: true,
  get: function get() {
    return _underlineLinkStyle.underlineLinkStyle;
  }
});
Object.defineProperty(exports, "internalLinkStyle", {
  enumerable: true,
  get: function get() {
    return _internalLinkStyle.internalLinkStyle;
  }
});
Object.defineProperty(exports, "getBlockerStyle", {
  enumerable: true,
  get: function get() {
    return _spinnerStyle.getBlockerStyle;
  }
});
Object.defineProperty(exports, "spinnerKeyframe", {
  enumerable: true,
  get: function get() {
    return _spinnerStyle.spinnerKeyframe;
  }
});
Object.defineProperty(exports, "uiblockerStyle", {
  enumerable: true,
  get: function get() {
    return _uiBlockerStyle.uiblockerStyle;
  }
});
Object.defineProperty(exports, "legacyUIBlockerStyle", {
  enumerable: true,
  get: function get() {
    return _uiBlockerStyle.legacyUIBlockerStyle;
  }
});
Object.defineProperty(exports, "reactUIBlockerStyle", {
  enumerable: true,
  get: function get() {
    return _uiBlockerStyle.reactUIBlockerStyle;
  }
});
Object.defineProperty(exports, "getTopGridPanelCommonStyle", {
  enumerable: true,
  get: function get() {
    return _topGridPanelStyle.getTopGridPanelCommonStyle;
  }
});
Object.defineProperty(exports, "columnChooserStyle", {
  enumerable: true,
  get: function get() {
    return _columnChooserStyle.columnChooserStyle;
  }
});
Object.defineProperty(exports, "getColumnChooserOverrideStyle", {
  enumerable: true,
  get: function get() {
    return _columnChooserOverrideStyle.getColumnChooserOverrideStyle;
  }
});
Object.defineProperty(exports, "filterEditorStyle", {
  enumerable: true,
  get: function get() {
    return _filterEditorStyle.filterEditorStyle;
  }
});
Object.defineProperty(exports, "getFilterEditorOverrideStyle", {
  enumerable: true,
  get: function get() {
    return _filterEditorOverrideStyle.getFilterEditorOverrideStyle;
  }
});
Object.defineProperty(exports, "getLegacyFilterBarStyle", {
  enumerable: true,
  get: function get() {
    return _legacyFilterBarStyle.getLegacyFilterBarStyle;
  }
});
Object.defineProperty(exports, "GridSharedStyles", {
  enumerable: true,
  get: function get() {
    return _gridShared.GridSharedStyles;
  }
});

var _alertStyle = __webpack_require__(3);

var _buttonInputStyle = __webpack_require__(4);

var _buttonStyle = __webpack_require__(5);

var _closeImageStyle = __webpack_require__(6);

var _control = __webpack_require__(7);

var _datePickerStyle = __webpack_require__(8);

var _dropDownEditorStyle = __webpack_require__(9);

var _fabricPanelStyle = __webpack_require__(10);

var _floatButtonStyle = __webpack_require__(11);

var _gridInlineErrorStyle = __webpack_require__(12);

var _helpButtonStyle = __webpack_require__(13);

var _inlineEditorStyle = __webpack_require__(14);

var _inlineErrorStyle = __webpack_require__(15);

var _scrollbarStyle = __webpack_require__(16);

var _searchBoxStyle = __webpack_require__(17);

var _searchBox = __webpack_require__(18);

var _entitySelectorStyle = __webpack_require__(19);

var _paginationStyle = __webpack_require__(20);

var _statusStyle = __webpack_require__(21);

var _toggleButtonStyle = __webpack_require__(22);

var _underlineLinkStyle = __webpack_require__(23);

var _internalLinkStyle = __webpack_require__(24);

var _spinnerStyle = __webpack_require__(25);

var _uiBlockerStyle = __webpack_require__(26);

var _topGridPanelStyle = __webpack_require__(31);

var _columnChooserStyle = __webpack_require__(32);

var _columnChooserOverrideStyle = __webpack_require__(33);

var _filterEditorStyle = __webpack_require__(35);

var _filterEditorOverrideStyle = __webpack_require__(36);

var _legacyFilterBarStyle = __webpack_require__(37);

var _gridShared = __webpack_require__(38);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alertStyle = void 0;

const alertStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '& .alert': {
    border: 'none',
    boxShadow: 'none',
    color: palette.neutralPrimary,
    display: 'flex',
    fontSize: 12,
    height: 'auto',
    lineHeight: '16px',
    padding: '8px 32px 8px 8px',
    '&.alert-danger .alert-image:before': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      lineHeight: '16px',
      color: '#A80000',
      marginRight: 8,
      content: '"\\EA39"'
    },
    '&.alert-info .alert-image:before': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      lineHeight: '16px',
      color: palette.neutralSecondary,
      marginRight: 8,
      content: '"\\E946"'
    },
    '&.alert-warning .alert-image:before': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      lineHeight: '16px',
      color: '#d83b01',
      marginRight: 8,
      content: '"\\E7BA"'
    }
  }
});

exports.alertStyle = alertStyle;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonInputStyle = void 0;

const buttonInputStyle = ({
  palette = {}
}) => ({
  '& input.btn-primary[type="button"], input.btn-primary[type="submit"], input.btn-hero[type="button"]': {
    '&:focus': {
      boxShadow: `inset 0 0 0 1px ${palette.white}`,
      border: `2px solid ${palette.themePrimary}`
    }
  },
  '& input.btn-default[type="button"]': {
    '&:focus': {
      outline: `1px solid ${palette.neutralSecondaryAlt}`,
      boxShadow: `inset 0 0 0 1px ${palette.neutralSecondary}`,
      outlineOffset: 0,
      border: `2px solid ${palette.white}`
    }
  }
});

exports.buttonInputStyle = buttonInputStyle;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.btnStyle = exports.btnInteractStyle = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const btnInteractStyle = ({
  palette = {}
}) => ({
  '&:hover': {
    background: palette.neutralLighter
  },
  '&:focus': {
    background: palette.neutralLight,
    border: `1px solid ${palette.neutralSecondaryAlt}`
  }
});

exports.btnInteractStyle = btnInteractStyle;

const btnStyle = ({
  palette = {}
}) => {
  const primary = {
    height: 32,
    minWidth: 80,
    background: palette.themePrimary,
    borderRadius: 2,
    textAlign: 'center',
    color: palette.white,
    boxSizing: 'border-box',
    '&:hover': {
      background: palette.themeDarkAlt
    },
    '&:focus': {
      background: palette.themePrimary,
      outline: 'none'
    },
    '&:active': {
      background: palette.themeDark
    },
    '&:disabled': {
      background: palette.neutralLighter,
      color: palette.neutralTertiary
    }
  };
  return {
    '.btn-primary': primary,
    '.btn-hero': primary,
    '.btn-default': _objectSpread({
      height: 32,
      minWidth: 80,
      background: palette.white,
      borderRadius: 2,
      textAlign: 'center',
      color: palette.neutralPrimary,
      border: `1px solid ${palette.neutralSecondaryAlt}`
    }, btnInteractStyle({
      palette
    }), {
      '&:disabled': {
        background: palette.neutralLighter,
        color: palette.neutralTertiary
      }
    })
  };
};

exports.btnStyle = btnStyle;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeImageStyle = void 0;

const closeImageStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '.closeimage': {
    fontFamily: iconFontFamily,
    color: palette.neutralSecondary,
    cursor: 'pointer',
    right: -8,
    position: 'relative'
  },
  '.closeimage:before': {
    content: '"\\E711"'
  }
});

exports.closeImageStyle = closeImageStyle;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.controlStyle = void 0;

const controlStyle = ({
  palette = {}
}) => ({
  '.form-control': {
    '-webkit-box-shadow': 'none',
    backgroundColor: palette.white,
    backgroundImage: 'none',
    border: `1px solid ${palette.neutralSecondary}`,
    borderRadius: 2,
    boxShadow: 'none',
    color: palette.neutralPrimary,
    display: 'block',
    fontSize: 14,
    height: 32,
    lineHeight: 1.5,
    padding: '6px 12px',
    transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',
    '&:active': {
      borderColor: palette.themePrimary
    },
    '&:hover': {
      borderColor: palette.neutralPrimary
    },
    '&:focus': {
      '-webkit-box-shadow': 'none',
      borderColor: palette.themePrimary,
      boxShadow: 'none',
      outline: 0
    }
  }
});

exports.controlStyle = controlStyle;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerStyle = void 0;

/* eslint-disable no-unused-vars */
const datePickerStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets',
  focusedStyle
}) => ({
  '.k-animation-container': {
    width: '220px !important',
    height: 'auto !important',
    background: palette.white,
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
    borderRadius: 2,
    '& .k-calendar-container': {
      position: 'relative !important',
      padding: 12,
      width: '100%',
      height: '100%',
      '& .k-link:hover': {
        backgroundColor: `${palette.neutralLight} !important`,
        color: `${palette.neutralDark} !important`
      },
      '& .k-header': {
        width: '100%',
        paddingBottom: 4,
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        '& .k-nav-fast': {
          order: '1',
          flex: '1',
          lineHeight: '19px',
          fontWeight: 600,
          textAlign: 'left',
          display: 'flex',
          paddingTop: 4,
          paddingBottom: 5,
          color: palette.neutralPrimary
        },
        '& .k-nav-prev': {
          order: '2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        '& .k-nav-next': {
          order: '3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        '& .k-icon': {
          fontFamily: iconFontFamily,
          fontSize: 12,
          lineHeight: '12px',
          width: 28,
          height: '28px',
          padding: 8,
          color: palette.neutralSecondary
        },
        '& .k-i-arrow-w:before': {
          content: '"\\E74A"'
        },
        '& .k-i-arrow-e:before': {
          content: '"\\E74B"'
        }
      },
      '& .k-content': {
        '& th, td': {
          width: 28,
          height: '28px',
          textAlign: 'center',
          fontWeight: 'normal',
          background: palette.white,
          borderRadius: 2,
          lineHeight: '16px',
          fontSize: 12,
          '& a': {
            color: '#212121',
            display: 'flex',
            width: '28px',
            height: '28px',
            alignItems: 'center',
            justifyContent: 'center'
          }
        },
        '& .k-link': {
          background: palette.neutralLighter,
          borderRadius: '2px'
        },
        '& .k-other-month .k-link': {
          background: palette.white
        },
        '& .k-state-selected': {
          '& .k-link': {
            // outline will only be visible when media query (forced-colors: active)
            outline: '1px dashed transparent',
            background: palette.themePrimary,
            fontWeight: 600,
            color: palette.white
          }
        },
        '& .k-today': {
          '& .k-link': {
            // outline will only be visible when media query (forced-colors: active)
            outline: '1px dotted transparent',
            background: palette.themeLighter,
            fontWeight: 600,
            color: palette.neutralDark
          }
        },
        '& .k-state-focused': {
          '& .k-link': focusedStyle || {
            // outline will only be visible when media query (forced-colors: active)
            outline: '1px solid transparent',
            background: palette.themePrimary,
            fontWeight: 600,
            color: palette.white
          }
        }
      },
      '& .k-meta-view': {
        '& tr': {
          '& td': {
            background: `${palette.white} !important`,
            '& a': {
              display: 'flex',
              color: `${palette.neutralPrimary} !important`,
              width: '36px',
              height: '36px',
              marginBottom: 20,
              marginRight: 17,
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          '& td:last-child': {
            '& a': {
              marginRight: 0
            }
          }
        },
        '& .k-state-focused': {
          '& a': {
            color: `${palette.neutralDark} !important`,
            background: palette.themeLighter
          }
        }
      }
    }
  }
});

exports.datePickerStyle = datePickerStyle;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropDownEditorStyle = void 0;

const dropDownEditorStyle = ({
  palette = {}
}) => ({
  '& .grid-editable-cell select.editor-control.select-editor': {
    borderWidth: '0px 0px 1px 0px',
    borderBottomColor: 'transparent',
    paddingBottom: 8,
    paddingTop: 8,
    '&:hover, &:focus, &:active': {
      borderBottomColor: 'unset',
      outline: 'none'
    },
    '&:active': {
      borderBottomColor: palette.themePrimary
    }
  }
});

exports.dropDownEditorStyle = dropDownEditorStyle;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fabricPanelStyle = void 0;

const fabricPanelStyle = () => ({
  footer: {
    background: 'white',
    zIndex: 1
  },
  commands: {
    marginTop: 0,
    marginBottom: 0,
    zIndex: 1
  }
});

exports.fabricPanelStyle = fabricPanelStyle;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.floatButtonStyle = void 0;

const floatButtonStyle = ({
  palette = {}
}) => ({
  floatButton: {
    background: palette.neutralLighter,
    border: 'none',
    borderRadius: 0,
    color: palette.themeDarkAlt,
    fontWeight: 'normal',
    height: 'auto',
    minHeight: 'auto',
    minWidth: 'auto',
    width: 'auto',
    padding: '14px 8px',
    '&:active, &:focus, &:hover': {
      color: palette.themeDark,
      background: palette.neutralQuaternaryAlt
    }
  }
});

exports.floatButtonStyle = floatButtonStyle;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridInlineErrorStyle = void 0;

const gridInlineErrorStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '& .inline-editor-errors': {
    '& .error-messages': {
      listStyleType: 'none',
      marginBottom: 0,
      '& .error': {
        fontFamily: iconFontFamily,
        padding: '10px',
        fontSize: '10pt',
        '&:before': {
          content: '"\\EA39"',
          color: palette.red
        }
      },
      '& .error-message': {
        fontSize: '14px'
      }
    }
  }
});

exports.gridInlineErrorStyle = gridInlineErrorStyle;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpbuttonStyle = void 0;

const helpbuttonStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '.helpbutton': {
    fontSize: 15,
    color: `${palette.themePrimary} !important`,
    verticalAlign: 'middle',
    fontWeight: 'normal',
    marginLeft: 7,
    '&:focus': {
      outline: '1px solid',
      outlineColor: palette.neutralSecondary,
      border: 'none',
      color: palette.black,
      textDecoration: 'none'
    },
    '&:hover': {
      backgroundColor: palette.neutralLighter,
      color: palette.black,
      textDecoration: 'none'
    },
    '&:active': {
      backgroundColor: palette.neutralLight,
      color: palette.black,
      textDecoration: 'none'
    }
  },
  '.helpbutton::before': {
    content: '"\\E9CE"',
    fontFamily: iconFontFamily,
    position: 'relative',
    top: 2
  }
});

exports.helpbuttonStyle = helpbuttonStyle;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineEditorStyle = void 0;

const InlineEditorStyle = () => ({
  '.custom-parameters-inline-edit-popup': {
    width: 456,
    minWidth: 456
  },
  '.grid-popupeditor .form-inline .form-group': {
    display: 'block'
  }
});

exports.InlineEditorStyle = InlineEditorStyle;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inlineErrorStyle = void 0;

const inlineErrorStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '.inline-editor-errors': {
    '& .error-messages': {
      listStyleType: 'none',
      '& .grid-error': {
        '&.spritedimage': {
          fontFamily: iconFontFamily,
          padding: '10px',
          fontSize: '10pt'
        },
        '&.spritedimage:before': {
          content: '"\\EA39"',
          color: palette.red
        }
      },
      '& .error-message': {
        fontSize: '14px'
      }
    }
  }
});

exports.inlineErrorStyle = inlineErrorStyle;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollbarStyle = void 0;

/* eslint-disable no-unused-vars */
const scrollbarStyle = ({
  palette = {}
}) => ({
  '::-webkit-scrollbar': {
    width: 4,
    backgroundColor: 'transparent'
  },
  '::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },
  '::-webkit-scrollbar-thumb': {
    width: 4,
    height: 44,
    backgroundColor: '#EBEAE8'
  },
  '::-webkit-scrollbar:horizontal': {
    height: 4,
    backgroundColor: 'transparent'
  },
  '::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'transparent'
  },
  '::-webkit-scrollbar-thumb:horizontal': {
    width: 200,
    height: 4,
    backgroundColor: '#EBEAE8'
  }
});

exports.scrollbarStyle = scrollbarStyle;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchboxStyle = void 0;

const searchboxStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '& .searchbox': {
    padding: 0
  },
  '& .searchbox .form-horizontal': {
    width: '100%'
  },
  '& .searchbox-input': {
    paddingLeft: 40
  },
  '& .searchbox .form-control': {
    border: 0,
    borderBottom: `1px solid ${palette.neutralLighter}`
  },
  '& .filter_search_icon_small': {
    fontFamily: iconFontFamily,
    color: palette.themePrimary,
    fontSize: 14
  },
  '& .filter_search_icon_small:before': {
    content: '"\\E721"'
  }
});

exports.searchboxStyle = searchboxStyle;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBox = void 0;
const SearchBox = {
  inputGroup: {
    position: 'relative',
    overflow: 'hidden'
  },
  input: {
    border: {
      width: 1,
      style: 'solid'
    },
    padding: {
      top: 3,
      right: 33,
      bottom: 3,
      left: 8
    },
    display: 'block',
    width: '100%',
    fontSize: '1em'
  },
  icon: {
    position: 'absolute',
    right: 60,
    height: 15,
    marginTop: 5,
    width: 20,
    fontSize: 12,
    '&:hover': {
      cursor: 'pointer'
    }
  }
};
exports.SearchBox = SearchBox;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entitySelectorStyle = void 0;

const entitySelectorStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '& .ba-campaign-selector, & .ba-campaign-adgroup-selector': {
    '& .ba-list-selector': {
      border: '1px solid #BBB',
      height: 300,
      display: 'flex',
      flexDirection: 'column',
      '& .list-selector-item': {
        position: 'relative'
      },
      '& .list-selector-content': {
        flex: 1,
        overflow: 'auto'
      },
      '& .list-selector-select-all-bar': {
        padding: '5px 10px',
        color: '#1470A5',
        cursor: 'pointer',
        '& .arrow-button.enabled': {
          marginLeft: 6
        },
        '& .arrow-button.remove': {
          marginRight: 6
        },
        '& .enabled.arrow-button:before, & .arrow-button.remove:before': {
          verticalAlign: 'middle'
        }
      }
    },
    '& .multi-selector': {
      '& .ba-entity-selector': {
        '& .ba-list-selector': {
          '& .list-selector-item': {
            padding: 0,
            '& .multi-item-container': {
              padding: '7px 8px 8px 8px'
            },
            '& .added-to-result-list': {
              backgroundColor: '#edebe9'
            }
          }
        }
      }
    }
  },
  '& .ba-campaign-adgroup-selector .selected-item, .ba-campaign-selector .selected-item': {
    maxWidth: 270
  },
  '& .ba-campaign-selector, & .ba-campaign-adgroup-selector, & .disclaimer-selector, & .audience-planner-location-selector': {
    '& .dropdown-toggle': {
      lineHeight: 2,
      padding: '0 8px',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      width: 320,
      textAlign: 'left !important',
      background: 'transparent !important',
      border: `1px solid ${palette.neutralSecondary}`,
      borderRadius: 2,
      outline: 'none',
      '&:hover': {
        borderColor: palette.neutralPrimary
      },
      '&:focus, &:active': {
        borderColor: palette.themePrimary
      },
      '& .selected-item': {
        textOverflow: 'ellipsis',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        verticalAlign: 'middle'
      },
      '& .icon-right': {
        float: 'right'
      },
      '& .glyphicon-triangle-bottom, .glyphicon-pencil': {
        marginTop: 5,
        fontFamily: iconFontFamily,
        fontSize: 16,
        verticalAlign: 'middle',
        color: palette.neutralSecondary
      },
      '& .glyphicon-triangle-bottom:before': {
        content: '"\\E70D"'
      },
      '& .glyphicon.glyphicon-pencil::before': {
        content: '"\\E70F"'
      }
    },
    '& .dropdown-toggle:focus:after, .dropdown-toggle:active:after': {
      border: 0
    },
    '& .dropdown-menu': {
      top: 'auto',
      left: 'auto',
      minWidth: 320,
      padding: 8,
      boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.108), 0px 3.2px 7.2px rgba(0, 0, 0, 0.132)',
      borderRadius: '0px 0px 2px 2px',
      '& .ba-search-box ': {
        borderTop: `1px solid ${palette.neutralSecondary}`,
        borderLeft: `1px solid ${palette.neutralSecondary}`,
        borderRight: `1px solid ${palette.neutralSecondary}`,
        padding: 1,
        position: 'relative',
        '& .search-box__input': {
          height: 48,
          width: 'calc(100% - 2px)',
          border: 0,
          borderBottom: `1px solid ${palette.neutralLight}`,
          paddingLeft: 48,
          marginLeft: 1
        },
        '& .search-box__icon': {
          fontFamily: iconFontFamily,
          fontSize: 16,
          verticalAlign: 'middle',
          position: 'absolute',
          left: 16,
          top: 16
        },
        '& .search-box__icon:before': {
          content: '"\\E721"',
          color: palette.themePrimary
        }
      },
      '& .ba-list-selector': {
        borderBottom: `1px solid ${palette.neutralSecondary}`,
        borderLeft: `1px solid ${palette.neutralSecondary}`,
        borderRight: `1px solid ${palette.neutralSecondary}`,
        '& .list-selector-header': {
          '& .panel-heading': {
            color: palette.neutralPrimary,
            fontSize: 14,
            padding: '7px 8px',
            '& .panel-title': {
              fontSize: 14,
              marginTop: 0
            }
          }
        },
        '& .list-selector-content': {
          height: 380,
          '& .list-selector-item': {
            padding: '7px 8px 8px 8px',
            margin: 0,
            minHeight: 36,
            '& > div, & .item-content': {
              maxWidth: 225,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              paddingRight: '20px',
              '& .statusIcon': {
                verticalAlign: 'middle',
                height: '19px'
              },
              '& .text': {
                marginLeft: 10,
                verticalAlign: 'middle'
              }
            }
          },
          '& .selected': {
            background: palette.neutralLight
          }
        },
        '& .list-selector-item:hover': {
          background: palette.neutralLight
        },
        '& .list-selector-item:focus': {
          outline: 'none',
          border: `1px solid ${palette.neutralSecondary}`
        }
      },
      '& .list-selector-empty': {
        marginLeft: 10
      },
      '& .ba-cascader-selector': {
        border: 0,
        padding: 0
      },
      '& .ba-cascader-selector>div': {
        width: '100% !important',
        marginBottom: 0
      },
      '& .ba-cascader-selector>div:nth-child(2)>div:nth-child(2)': {
        '& .ba-list-selector': {
          borderLeft: '0 !important'
        }
      },
      '& .pagination-container': {
        '& .ba-pagination': {
          height: 36,
          padding: '6px 0',
          paddingBottom: 0
        }
      }
    }
  },
  '& .ba-campaign-adgroup-selector, & .ba-campaign-selector': {
    '& .dropdown-toggle .dropdown-edit-mode-parent-text': {
      color: '#605e5c'
    },
    '& .item-content-parent-info': {
      color: '#605e5c'
    }
  }
});

exports.entitySelectorStyle = entitySelectorStyle;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationStyle = void 0;

const paginationStyle = ({
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '& .ba-pagination, .dlb-pager-container, .pagination-control': {
    height: 'auto',
    padding: '6px 0',
    '& > .text': {
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '0px 0px 8px 5px',
      '& > span': {
        marginRight: '5px'
      }
    },
    '& button': {
      border: 0,
      background: 'transparent',
      minWidth: '1px',
      padding: 0,
      color: palette.neutralSecondary
    },
    '& button:hover': {
      borderRadius: 2,
      background: palette.neutralLighter
    },
    '& button:disabled': {
      background: 'transparent',
      color: '#BEBBB8'
    },
    '& .prev + .text, .pager-previous + .text': {
      display: 'none'
    },
    '& .pager-input': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: '6px 8px',
      height: 32,
      textAlign: 'center',
      margin: '0 12px',
      width: 70,
      display: 'inline-block',
      borderRadius: 2,
      boxSizing: 'border-box',
      color: palette.neutralPrimary,
      '&:active': {
        borderColor: palette.themePrimary
      },
      '&:focus': {
        borderColor: palette.themePrimary,
        outline: 0
      },
      '&:hover': {
        borderColor: palette.neutralPrimary
      }
    },
    '& .glyphicon-triangle-left, & .glyphicon-triangle-right': {
      display: 'inline-block',
      fontFamily: iconFontFamily,
      color: 'inherit'
    },
    '& .glyphicon-triangle-left:before': {
      content: '"\\E76B"'
    },
    '& .glyphicon-triangle-right:before': {
      content: '"\\E76C"'
    }
  },
  '& .pager, .location-bid-pager-view': {
    height: 32,
    padding: 0,
    margin: 0,
    '& .pager-input, .page-number-input, .grid-pager-input': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: '6px 8px',
      height: 32,
      textAlign: 'center',
      margin: '0 12px',
      width: '70px !important',
      display: 'inline-block',
      borderRadius: 2,
      boxSizing: 'border-box',
      color: palette.neutralPrimary,
      background: palette.white
    },
    '& .pager-input[disabled], & .page-number-input[disabled], & .grid-pager-input[disabled]': {
      backgroundColor: palette.neutralLighter
    },
    '& .pager-previous, & .pager-next, & .glyphicon-triangle-left, & .glyphicon-triangle-right': {
      fontFamily: iconFontFamily,
      color: palette.neutralSecondary,
      background: 'transparent',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '2px 5px',
      height: 32,
      lineHeight: '32px',
      marginTop: '-7px',
      outline: 'none'
    },
    '& .pager-previous, & .pager-next': {
      '&:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: '-2px'
      }
    },
    '& .pager-previous:hover, & .pager-next:hover': {
      borderRadius: 2,
      background: palette.neutralLighter
    },
    '& .pager-previous-disabled, & .pager-next-disabled': {
      fontFamily: iconFontFamily,
      color: '#BEBBB8',
      background: 'transparent',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '2px 5px',
      height: 32,
      lineHeight: '32px',
      marginTop: '-7px',
      outline: 'none'
    },
    '& .pager-previous-disabled:before, & .pager-previous:before': {
      content: '"\\E76B"'
    },
    '& .pager-next-disabled:before, & .pager-next:before': {
      content: '"\\E76C"'
    },
    '& .pager-totalCount': {
      verticalAlign: 'unset',
      marginLeft: 4
    }
  },
  '& .pagination-control': {
    textAlign: 'left',
    '& .text': {
      display: 'inline-block',
      width: 'auto'
    },
    '& .page-size-selector': {
      height: 32,
      textAlign: 'center',
      margin: '0 12px',
      width: '70px !important',
      display: 'inline-block',
      borderRadius: 2,
      boxSizing: 'border-box',
      color: palette.neutralPrimary
    },
    '& .pager': {
      display: 'inline-block'
    }
  }
});

exports.paginationStyle = paginationStyle;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusStyle = void 0;

const statusStyle = ({
  palette = {}
}) => ({
  '& .statusDraft_icon': {
    display: 'inline-block',
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal'
  },
  '& .statusDraft_icon::before': {
    content: '"\\F6B0"',
    color: palette.neutralPrimary
  },
  '& .statusDeleted_icon': {
    display: 'inline-block',
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal'
  },
  '& .statusDeleted_icon::before': {
    content: '"\\E738"',
    color: palette.redOrange10
  },
  '& .statusEnabled_icon': {
    display: 'inline-block',
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal'
  },
  '& .statusEnabled_icon::before': {
    content: '"\\ECCC"',
    color: palette.green
  },
  '& .statusExcluded_icon': {
    display: 'inline-block',
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal'
  },
  '& .statusExcluded_icon::before': {
    content: '"\\E733"',
    color: '#A80000'
  },
  '& .statusPaused_icon': {
    display: 'inline-block',
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal'
  },
  '& .statusPaused_icon::before': {
    content: '"\\F6B0"',
    color: palette.neutralPrimary
  },
  '& .statushypendisplay': {
    display: 'inline-block',
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal'
  },
  '& .statushypendisplay::before': {
    content: '"\\E738"',
    color: palette.neutralPrimary
  }
});

exports.statusStyle = statusStyle;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleButtonStyle = void 0;

const toggleButtonStyle = ({
  palette = {}
}) => ({
  '& .toggle': {
    display: 'inline-block',
    textDecoration: 'none',
    '& .toggle-button': {
      display: 'inline-block',
      boxsizing: 'border-box',
      width: 40,
      height: 20,
      padding: 4,
      lineHeight: '10px',
      border: '1px solid',
      borderRadius: 30,
      'transition-duration': '0.2s',
      '-webkit-transition-duration': '0.2s'
    },
    '& .toggle-handle': {
      display: 'inline-block',
      boxsizing: 'border-box',
      width: 10,
      height: 10,
      borderRadius: 5,
      borderWidth: 5,
      borderStyle: 'solid',
      verticalAlign: 'top',
      'transition-duration': '0.2s',
      '-webkit-transition-duration': '0.2s'
    }
  },
  '& .toggle-on': {
    '& .toggle-button': {
      backgroundColor: palette.themePrimary,
      borderColor: palette.themePrimary
    },
    '& .toggle-handle': {
      marginLeft: 20,
      borderColor: palette.white
    }
  },
  '& .toggle-off': {
    '& .toggle-button': {
      backgroundColor: palette.white,
      borderColor: '#333333'
    },
    '& .toggle-handle': {
      marginRight: 20,
      borderColor: '#333333'
    }
  }
});

exports.toggleButtonStyle = toggleButtonStyle;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.underlineLinkStyle = void 0;

const underlineLinkStyle = ({
  palette = {},
  elementLocator = 'a',
  isGreyBackground = false
}) => ({
  [`& ${elementLocator}`]: {
    textDecoration: 'underline',
    color: isGreyBackground ? palette.themeDarkAlt : palette.themePrimary,
    '&:focus': {
      textDecoration: 'underline',
      outline: `1px solid ${palette.neutralSecondary}`
    },
    '&:hover': {
      textDecoration: 'underline',
      color: palette.themeDarker
    }
  }
});

exports.underlineLinkStyle = underlineLinkStyle;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.internalLinkStyle = void 0;

const internalLinkStyle = ({
  palette = {},
  elementLocator = 'a',
  isGreyBackground = false
}) => ({
  [`& ${elementLocator}`]: {
    textDecoration: 'none',
    color: isGreyBackground ? palette.themeDarkAlt : palette.themePrimary,
    '&:focus': {
      textDecoration: 'none',
      outline: `1px solid ${palette.neutralSecondary}`
    },
    '&:hover': {
      textDecoration: 'underline',
      color: palette.themeDarker
    }
  }
});

exports.internalLinkStyle = internalLinkStyle;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerKeyframe = exports.getBlockerStyle = void 0;

const getBlockerStyle = (size, palette) => ({
  width: size,
  height: size,
  border: '2px solid',
  borderLeftColor: palette.themePrimary,
  borderRightColor: palette.themeLight,
  borderTopColor: palette.themeLight,
  borderBottomColor: palette.themeLight,
  borderRadius: '50%',
  animation: 'spinner 1s linear infinite',
  marginRight: 9
});

exports.getBlockerStyle = getBlockerStyle;
const spinnerKeyframe = {
  '@keyframes spinner': {
    to: {
      transform: 'rotate(360deg)'
    }
  }
};
exports.spinnerKeyframe = spinnerKeyframe;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reactUIBlockerStyle = exports.legacyUIBlockerStyle = exports.uiblockerStyle = void 0;

var _constants = __webpack_require__(27);

var _spinnerStyle = __webpack_require__(25);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// this style is in the body scope, out of the feature scope, so use as the global pattern
const uiblockerStyle = ({
  palette = {}
}) => Object.assign({
  '.blocker': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.4)'
  },
  '.blocker-global, .blocker-local': {
    backgroundColor: 'rgba(255,255,255,0.4)',
    position: 'absolute',
    zIndex: _constants.ZIndexShellComponents.Loader,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  '.blocker-global': {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  },
  '.blocker, .blocker-global, .blocker-local': {
    '& .blocker-indicator': {
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '10px',
      color: palette.themePrimary,
      top: 'calc(50% - 24px)',
      left: 'calc(50% - 58px)',
      position: 'absolute',
      '& .blocker-image': (0, _spinnerStyle.getBlockerStyle)(28, palette)
    }
  }
}, _spinnerStyle.spinnerKeyframe); // blocker defined in $.advertiser


exports.uiblockerStyle = uiblockerStyle;

const legacyUIBlockerStyle = ({
  palette = {}
}) => ({
  '.blocker-panel': {
    position: 'absolute',
    backgroundColor: 'rgba(255,255,255,0.4)'
  },
  '.blocker-panel + .blocker-indicator': {
    outline: 'none',
    backgroundColor: 'white',
    padding: '10px',
    color: palette.themePrimary,
    position: 'absolute',
    '& .blocker-image': _objectSpread({}, (0, _spinnerStyle.getBlockerStyle)(28, palette), {
      position: 'absolute'
    }),
    '& .blocker-text': {
      margin: '5px 0 0 40px'
    }
  }
}); // for @bingads-webui-react/ui-blocker


exports.legacyUIBlockerStyle = legacyUIBlockerStyle;

const reactUIBlockerStyle = (palette, backgroundColor = 'white') => ({
  '& .react-block-ui': {
    '& > div:last-child': {
      alignItems: 'center',
      backgroundColor,
      color: palette.themePrimary,
      display: 'flex',
      outline: 'none',
      padding: 10,
      '& .blocker-text': {
        fontWeight: 'normal'
      },
      '& .blocker-image': (0, _spinnerStyle.getBlockerStyle)(28, palette)
    }
  }
});

exports.reactUIBlockerStyle = reactUIBlockerStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ZIndexShellComponents", {
  enumerable: true,
  get: function get() {
    return _zindexes.ZIndexShellComponents;
  }
});
Object.defineProperty(exports, "ZIndexContentComponents", {
  enumerable: true,
  get: function get() {
    return _zindexes.ZIndexContentComponents;
  }
});
Object.defineProperty(exports, "PagePadding", {
  enumerable: true,
  get: function get() {
    return _pagePadding.PagePadding;
  }
});
Object.defineProperty(exports, "ResponsiveSizeBreakpoints", {
  enumerable: true,
  get: function get() {
    return _responsiveSize.ResponsiveSizeBreakpoints;
  }
});

var _zindexes = __webpack_require__(28);

var _pagePadding = __webpack_require__(29);

var _responsiveSize = __webpack_require__(30);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZIndexContentComponents = exports.ZIndexShellComponents = void 0;
// For the z-index defined in external place, we use leading "_" in key name to indicate it,
// and put them here ONLY FOR REFERENCE.
// We only focus on z-index of components in app-layout-container and direct children of <body>.
// That's to say, it doesn't matter that z-index of element A inside Content is greater than
// element B inside Header: A will still shows behind B, since Content z-index < Header z-index.
const ZIndexShellComponents = {
  _HelpContainer: 1100,
  // defined in apex style file
  _BootstrapPopover: 1060,
  // defined in bootstrap of theme-2018
  _BootstrapModal: 1050,
  // defined in bootstrap of theme-2018
  _BootstrapModalBackdrop: 1040,
  // defined in bootstrap of theme-2018
  ModalBackDrop: 1040,
  Header: 1031,
  Loader: 1030,
  // should be less than Header
  Panel: 1000,
  TopBanner: 250,
  PromotionBanner: 250,
  Nav: 200,
  Status: 150,
  Menu: 100,
  Tab: 75,
  SubTab: 50,
  Content: 0
}; // This is the common place for elements inside ".app-shell-content"

exports.ZIndexShellComponents = ZIndexShellComponents;
const ZIndexContentComponents = {
  // add new elements here in descending order
  GridToolbar: 20,
  GridHeader: 20,
  StatusPopup: 10
};
exports.ZIndexContentComponents = ZIndexContentComponents;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PagePadding = void 0;
const PagePadding = {
  mainSectionLeftPadding: 32,
  smallMainSectionLeftPadding: 15
};
exports.PagePadding = PagePadding;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveSizeBreakpoints = void 0;
const ResponsiveSizeBreakpoints = [{
  name: 's',
  minWidth: 360
}, {
  name: 'm',
  minWidth: 480
}, {
  name: 'l',
  minWidth: 640
}, {
  name: 'xl',
  minWidth: 1024
}, {
  name: 'xxl',
  minWidth: 1366
}];
exports.ResponsiveSizeBreakpoints = ResponsiveSizeBreakpoints;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopGridPanelCommonStyle = void 0;

var _internalLinkStyle = __webpack_require__(24);

var _underlineLinkStyle = __webpack_require__(23);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Styles for panel itself
const getTopGridPanelCommonStyle = ({
  palette
}) => ({
  '& .panel': _objectSpread({
    // All top of grid panel have same margin left and top
    marginTop: '24px',
    marginLeft: '32px',
    marginBottom: '0px',
    padding: 0,
    backgroundColor: 'white'
  }, (0, _underlineLinkStyle.underlineLinkStyle)({
    palette,
    elementLocator: 'a.HelpTopic'
  }), {
    '& .alert-info .alert-info-inline': _objectSpread({}, (0, _internalLinkStyle.internalLinkStyle)({
      palette,
      elementLocator: '> a',
      isGreyBackground: true
    })),
    '& .panel-heading': {
      backgroundColor: 'white',
      padding: '0px',
      fontWeight: 600,
      '& .panel-title': {
        fontSize: '20px',
        lineHeight: '27px',
        fontWeight: 600
      }
    },
    '& .panel-body': {
      lineHeight: '19px',
      paddingLeft: '0px',
      paddingBottom: '0px',
      marginBottom: '18px',
      // leave space between body and the footer buttons
      '& hr': {
        margin: 0,
        borderTop: '0px'
      }
    },
    '& .panel-footer': {
      borderTop: `1px solid ${palette.neutralLight}`,
      paddingTop: '16px',
      paddingBottom: '16px',
      paddingLeft: '0px',
      marginTop: 0,
      backgroundColor: 'white',
      '& input.btn, & button.btn': {
        marginRight: '8px'
      },
      '& input.btn:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: '-3px'
      },
      '& input.btn-primary:focus': {
        outline: '1px solid #fff'
      },
      '& .previewTable': {
        margin: '5px 0 !important',
        maxHeight: '250px',
        display: 'inline-block',
        minWidth: '500px',
        width: 'auto !important'
      }
    }
  })
});

exports.getTopGridPanelCommonStyle = getTopGridPanelCommonStyle;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnChooserStyle = void 0;
const columnChooserStyle = {
  '& .column-chooser .option': {
    padding: '6px 10px'
  },
  '& .column-chooser .option:hover': {
    backgroundColor: 'transparent',
    borderColor: 'transparent'
  },
  '& .column-chooser input[type="checkbox"]': {
    margin: '0 5px 0 0'
  },
  '& .column-chooser-instructions': {
    marginBottom: '35px'
  },
  '& .column-chooser-categories': {
    position: 'relative',
    float: 'left',
    width: '180px',
    left: '1px',
    zIndex: '1'
  },
  '& .column-chooser-list': {
    position: 'relative',
    border: '1px solid #bbb',
    background: 'white',
    boxSizing: 'border-box',
    height: '300px',
    width: '340px',
    float: 'left',
    overflow: 'hidden'
  },
  '& .column-chooser-list+.column-chooser-list': {
    marginLeft: '8px'
  },
  '& .column-chooser-list.right': {
    marginLeft: '10px'
  },
  '& .column-chooser-option-header': {
    padding: '10px',
    backgroundColor: '#f4f4f4',
    width: '340px'
  },
  '& .column-chooser-bulk-control': {
    padding: '10px'
  },
  '& .column-chooser-category': {
    padding: '10px',
    cursor: 'pointer',
    borderTop: '0'
  },
  '& .column-chooser-category.active': {
    backgroundColor: 'white',
    border: '1px solid #bbb',
    borderRightColor: 'white',
    borderRight: '0'
  },
  '& .column-chooser-category:focus, & .column-chooser-category.k-state-focused': {
    outline: '1px dashed #333 !important'
  },
  '& .column-chooser-options': {
    listStyle: 'none',
    verticalAlign: 'top',
    overflowX: 'visible',
    overflowY: 'auto',
    padding: '0 10px',
    height: '230px'
  },
  '& .column-chooser-options.selected': {
    padding: '10px',
    height: '290px'
  },
  '& .column-chooser-options.available': {
    height: '250px'
  },
  '& .column-chooser-option': {
    border: '1px solid white',
    borderLeftWidth: '0',
    borderRightWidth: '0',
    padding: '6px 10px'
  },
  '& .column-chooser-option:hover': {
    backgroundColor: '#e5e5e5',
    borderColor: '#e5e5e5'
  },
  '& .column-chooser-message': {
    marginBottom: '15px',
    fontSize: '12px'
  },
  '& .column-chooser-option-selected': {
    cursor: 'move',
    padding: '5px',
    marginBottom: '5px',
    backgroundColor: '#e7f0f6',
    border: '1px solid #1570a6',
    height: '28px !important'
  },
  '& .column-chooser-option-selected:hover': {
    backgroundColor: '#f4f4f4',
    borderColor: '#606060'
  },
  '& .column-chooser-option-selected .remove': {
    paddingTop: '2px'
  },
  '& .column-chooser-option-fixed': {
    cursor: 'not-allowed'
  },
  '& .column-chooser-option-unmovable': {
    backgroundColor: '#e5e5e5',
    borderColor: 'gray',
    cursor: 'not-allowed',
    padding: '7px'
  },
  '& .column-chooser-option-placeholder': {
    border: '1px solid #1570a6',
    opacity: '& .5',
    margin: '6px 10px',
    height: '20px'
  },
  '& .column-chooser': {
    display: 'block !important',
    lineHeight: '15px',
    fontWeight: 'normal'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area': {
    display: 'inline-block'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option': {
    float: 'left',
    padding: '0',
    backgroundColor: '#f4f4f4',
    border: 'none'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .column-chooser-option-header': {
    padding: '10px',
    width: '340px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .column-chooser-search-box': {
    border: '1px solid #F3F2F1',
    position: 'relative'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .search-input': {
    border: 'none',
    height: '48px',
    paddingLeft: '48px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .glyphicon-search': {
    top: '16px',
    left: '16px',
    color: '#0078d4',
    position: 'absolute',
    fontSize: '16px',
    fontFamily: 'MsAds MDL2 Assets'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .glyphicon-search:before': {
    content: '"\\E721"'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .category-tabs': {
    position: 'relative',
    left: '1px',
    zIndex: '1',
    marginBottom: '8.5px',
    marginTop: '0',
    paddingLeft: '0',
    float: 'left',
    width: '180px',
    listStyle: 'none'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .category-tabs>li': {
    padding: '10px',
    cursor: 'pointer',
    borderTop: '0'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .category-tabs>li.active': {
    backgroundColor: 'white',
    border: '1px solid #BBB',
    borderRightColor: 'white',
    borderRight: '0',
    fontWeight: 'bold'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view': {
    float: 'left'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list': {
    position: 'relative',
    border: '1px solid #BBB',
    background: 'white',
    boxSizing: 'border-box',
    height: '300px',
    width: '340px',
    overflow: 'hidden'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list .column-chooser-bulk-control': {
    padding: '10px',
    textAlign: 'right'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list ul.column-chooser-options': {
    listStyle: 'none',
    verticalAlign: 'top',
    overflowX: 'visible',
    overflowY: 'auto',
    padding: '0 10px',
    height: '250px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list ul.column-chooser-options span.option-not-selected': {
    fontWeight: 'bold'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list ul.column-chooser-options span.option-status': {
    float: 'right'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list ul.column-chooser-options span.option-status.disabled': {
    color: '#ccc'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-option .options-view .column-chooser-option-list ul.column-chooser-options a.add-column-link': {
    float: 'right'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected': {
    float: 'left'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .column-chooser-selected-header': {
    padding: '10px',
    backgroundColor: '#f4f4f4',
    width: '340px',
    marginLeft: '0'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view': {
    position: 'relative',
    border: '1px solid #BBB',
    background: 'white',
    boxSizing: 'border-box',
    height: '300px',
    width: '340px',
    overflow: 'hidden',
    marginLeft: '10px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view ul.draggable-list': {
    padding: '10px',
    height: '290px',
    overflowX: 'visible',
    overflowY: 'auto'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view ul.draggable-list li.draggable-list-item.draggable-list__item-locked': {
    backgroundColor: '#E5E5E5',
    marginBottom: '5px',
    border: '1px solid gray',
    cursor: 'not-allowed',
    padding: '7px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view ul.draggable-list li.draggable-list-item.draggable-list__item-draggable': {
    cursor: 'move',
    padding: '5px',
    marginBottom: '5px',
    backgroundColor: '#e7f0f6',
    border: '1px solid #008272',
    height: '28px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view ul.draggable-list li.draggable-list-item.draggable-list__item-draggable.draggable-list__item-preview': {
    opacity: '& .5',
    marginLeft: '10px',
    marginRight: '10px'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view ul.draggable-list li.draggable-list-item.draggable-list__item-draggable span.remove': {
    float: 'right'
  },
  '& .column-chooser .panel .panel-body .column-chooser-selection-area .column-chooser-selected .draggable-list-view ul.draggable-list li.draggable-list-item .selected-list-item span': {
    M: 'none',
    W: 'none',
    fallbacks: [{
      M: 'none'
    }],
    userSelect: 'none'
  },
  '& .column-chooser .panel .panel-body .save-column-view': {
    display: 'inline-block'
  },
  '& .column-chooser .panel .panel-body .save-column-view .save-checkbox': {
    height: '25px',
    verticalAlign: 'middle'
  },
  '& .column-chooser .panel .panel-body .save-column-view .save-checkbox .column-chooser-save-column': {
    fontWeight: 'normal'
  },
  '& .column-chooser .panel .panel-body .save-column-view .save-checkbox input.column-chooser-saved-name': {
    border: '1px solid #BBB',
    padding: '3px 5px',
    fontSize: '12px',
    lineHeight: '1.45833333'
  },
  '& .column-chooser .panel .panel-footer': {
    marginTop: '5px'
  },
  // From @bingads-webui/theme-2016/style/css/bootstrap/less/override/panels.less
  // scoped under .column-chooser
  '& .column-chooser .panel-component': {
    backgroundColor: '#E7F0F6'
  },
  '& .column-chooser .panel-component .panel-heading': {
    backgroundColor: '#E7F0F6'
  },
  '& .column-chooser .panel-component .panel-title': {
    fontColor: '#333'
  },
  '& .column-chooser .panel-component .panel-body': {
    padding: '5px 15px'
  },
  '& .column-chooser .panel-form': {
    backgroundColor: 'white',
    border: '1px solid #BBB',
    padding: '5px'
  },
  '& .column-chooser .panel-form.noPadding': {
    padding: '0'
  },
  '& .column-chooser .panel-form .panel-heading': {
    marginBottom: '0'
  },
  '& .column-chooser .panel-form .section': {
    padding: '0 0 15px 0'
  },
  '& .column-chooser .panel-form .panel-body.noPadding': {
    padding: '0'
  },
  '& .column-chooser .panel-form-footer': {
    padding: '3px 0'
  },
  '& .column-chooser .panel.panel-white': {
    backgroundColor: 'white',
    W: 'none',
    boxShadow: 'none'
  },
  '& .column-chooser .panel-body': {
    padding: '0 15px 0 15px'
  },
  '& .column-chooser .panel-body:before, & .column-chooser .panel-body:after': {
    content: '" "',
    display: 'table'
  },
  '& .column-chooser .panel-body:after': {
    clear: 'both'
  },
  '& .column-chooser .panel-heading': {
    backgroundColor: '#E5E5E5',
    padding: '0 15px',
    marginBottom: '15px'
  },
  '& .column-chooser .panel-heading>.dropdown .dropdown-toggle': {
    color: 'inherit'
  },
  '& .column-chooser .panel-title': {
    fontWeight: 'bold',
    marginTop: '0',
    marginBottom: '0',
    lineHeight: '30px',
    fontSize: 14,
    display: 'inline'
  },
  '& .column-chooser .panel-title>a': {
    color: 'inherit'
  },
  '& .column-chooser .panel-footer': {
    padding: '0 15px 0 15px',
    borderTop: '0px'
  },
  '& .column-chooser hr': {
    borderTop: '1px solid #A2A2A2'
  },
  '& .column-chooser .save-column-checkbox': {
    float: 'left'
  }
};
exports.columnChooserStyle = columnChooserStyle;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnChooserOverrideStyle = void 0;

var _newFeatureLabelStyle = __webpack_require__(34);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const getColumnChooserOverrideStyle = palette => ({
  // Shared part already moved to 'global-styles.js' to be shared with all top of grid panel.
  // Only put column chooser specific override here.
  '& .column-chooser': {
    display: 'block !important',
    lineHeight: '15px',
    fontWeight: 'normal',
    '& .panel': {
      '& .panel-body': {
        '& .column-chooser-selection-area': {
          padding: '0px 0px 18px 0px',
          '& .column-chooser-option': _objectSpread({
            backgroundColor: 'white',
            border: `1px solid ${palette.neutralTertiary}`
          }, (0, _newFeatureLabelStyle.getNewFeatureLabelStyle)({
            palette
          }), {
            '& .option': {
              height: '36px',
              display: 'flex',
              alignItems: 'center'
            },
            '& .column-chooser-option-header': {
              display: 'none'
            },
            '& .column-chooser-categories': {
              left: 0,
              width: '300px',
              '& .category-tabs': {
                left: 0,
                width: '300px',
                '& li a:after': {
                  fontFamily: '"MsAds MDL2 Assets"',
                  content: '"\\E76C"',
                  color: palette.neutralSecondary,
                  float: 'right'
                },
                '& > li': {
                  padding: '10px 8px 10px 10px',
                  '& .new-feature-label': {
                    display: 'inline-block',
                    position: 'absolute'
                  }
                },
                '& > li.active': {
                  fontWeight: 'normal',
                  border: 0,
                  backgroundColor: palette.neutralLight,
                  '& > a.currentActive': {
                    color: palette.themeDarker
                  }
                }
              }
            },
            '& .options-view .column-chooser-option-list': {
              border: '0px',
              borderLeft: `1px solid ${palette.neutralLight}`,
              width: '300px',
              height: '282px',
              '& .column-chooser-bulk-control': {
                padding: '10px 8px 9px 10px',
                minHeight: '38px',
                '& .arrow-button': {
                  display: 'none'
                }
              },
              '& ul.column-chooser-options': {
                height: '243.6px',
                '& span.option-not-selected': {
                  fontWeight: 'normal'
                },
                '& span.option-name': {
                  display: 'inline-block',
                  maxWidth: '165px',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                },
                '& .option-status, & a.add-column-link': {
                  marginLeft: 'auto'
                }
              },
              '& .column-chooser-editable-picker': {
                height: '282px',
                display: 'flex',
                flexDirection: 'column',
                '& .custom-column-remove': {
                  margin: '0px 10px'
                },
                '& .glyphicon-pencil': {
                  textDecoration: 'none',
                  '&:focus': {
                    outline: `1px solid ${palette.neutralSecondary}`
                  },
                  '&:before': {
                    fontFamily: 'MsAds MDL2 Assets',
                    content: '"\\E70F"',
                    color: palette.themeDark
                  }
                },
                '& .glyphicon-remove': {
                  textDecoration: 'none',
                  '&:focus': {
                    outline: `1px solid ${palette.neutralSecondary}`
                  },
                  '&:before': {
                    fontFamily: 'MsAds MDL2 Assets',
                    content: '"\\E711"'
                  }
                },
                '& span.option-status.enabled': {
                  marginLeft: 'auto'
                },
                '& a.add-column-link': {
                  marginLeft: 'auto'
                },
                '& .inapplicable-column': {
                  marginLeft: 'auto'
                },
                '& .column-chooser-bulk-control': {
                  padding: '0',
                  minHeight: '38px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  '& .custom-column-add': {
                    margin: '8px 8px 0px'
                  },
                  '& .remove-all-in-list, .add-all-in-list': {
                    padding: '10px 8px 9px 10px'
                  }
                },
                '& .invalid-custom-column:focus': {
                  outline: `1px solid ${palette.neutralSecondary}`
                },
                '& .column-chooser-options': {
                  flex: '1 1 1px',
                  margin: '0',
                  '& .option': {
                    display: 'flex',
                    alignItems: 'center',
                    '& .option-name': {
                      flex: '1'
                    }
                  }
                }
              }
            }
          }),
          '& .column-chooser-selected': {
            border: `1px solid ${palette.neutralTertiary}`,
            marginLeft: '8px',
            width: '300px',
            height: '334px',
            display: 'flex',
            flexDirection: 'column',
            '& .column-chooser-selected-header': {
              backgroundColor: 'white',
              padding: '10px 0px 10px 10px',
              width: '298px'
            },
            '& .column-chooser-selected-header:before': {
              content: 'Test new header',
              fontWeight: 'bold'
            },
            '& .column-chooser-selected-header:after': {
              content: 'Test new subheader'
            },
            '& .remove-all-in-selected-list': {
              marginLeft: 'auto',
              float: 'right',
              display: 'inline-block',
              paddingTop: '10px',
              paddingRight: '10px'
            },
            '& .column-chooser-selected-list': {
              flex: '1',
              overflow: 'auto',
              '& .draggable-list-view': {
                margin: 0,
                height: '100%',
                width: '298px',
                border: 0,
                '& ul.draggable-list': {
                  padding: 0,
                  listStyle: 'none',
                  height: '100%',
                  overflow: 'auto',
                  marginBottom: '0',
                  '& li.draggable-list-item': {
                    border: '1px solid transparent',
                    padding: '1px 0',
                    outline: 'none',
                    '&:focus': {
                      border: `1px solid ${palette.neutralTertiary}`
                    },
                    '& .selected-list-item': {
                      verticalAlign: 'middle',
                      display: 'flex',
                      alignItems: 'flex-start',
                      '& .selected-item-name': {
                        flex: '1',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                      },
                      '& .trigger-icon': {
                        color: '#797775',
                        fontFamily: '"MsAds MDL2 Assets"',
                        lineHeight: '19px',
                        padding: '0px 8px',
                        position: 'relative',
                        '&:after': {
                          color: palette.themePrimary,
                          content: '"\\E76F"',
                          fontSize: '20px'
                        }
                      }
                    },
                    '&.selected, &:focus, &:hover': {
                      '& .trigger-icon:before': {
                        content: '"\\F090\\F08E"',
                        fontSize: '14px',
                        letterSpacing: '3px',
                        marginTop: '-6px',
                        position: 'absolute',
                        writingMode: 'vertical-lr'
                      }
                    },
                    '&.selected': {
                      backgroundColor: palette.neutralLight,
                      '& .trigger-icon:before': {
                        color: palette.neutralPrimary
                      }
                    }
                  },
                  '& li.draggable-list-item.draggable-list__item-locked': {
                    height: '36px',
                    padding: '0px',
                    backgroundColor: 'white',
                    '& .selected-list-item': {
                      margin: '8px 8px 9px 36px'
                    }
                  },
                  '& li.draggable-list-item.draggable-list__item-draggable': {
                    height: '36px',
                    padding: '0px',
                    backgroundColor: 'white',
                    '& .selected-list-item': {
                      margin: '8px 8px 9px 0px'
                    }
                  }
                }
              }
            }
          }
        },
        '& .save-column-view': {
          '& .save-checkbox': {
            '& label+input': {
              marginLeft: '13px'
            },
            '& .column-chooser-save-column': {
              float: 'left',
              '& .save-column-checkbox': {
                height: '20px',
                width: '20px'
              },
              '& input[type="checkbox"]': {
                marginRight: '8px'
              }
            },
            '& .column-chooser-saved-name': {
              height: '32px',
              width: '250px'
            }
          }
        }
      }
    }
  }
});

exports.getColumnChooserOverrideStyle = getColumnChooserOverrideStyle;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewFeatureLabelStyle = void 0;

const getNewFeatureLabelStyle = ({
  palette = {}
}) => ({
  '& .new-feature-label': {
    color: palette.white,
    border: `1px solid ${palette.white}`,
    padding: '0 9px',
    fontSize: '12px',
    borderRadius: '12px',
    backgroundColor: palette.orange,
    marginLeft: '5px'
  }
});

exports.getNewFeatureLabelStyle = getNewFeatureLabelStyle;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterEditorStyle = void 0;
const filterEditorStyle = {
  '& .predicate-row': {
    display: 'flex',
    alignItems: 'center'
  },
  '& .filter-editor .panel': {
    backgroundColor: 'white',
    paddingBottom: '15px',
    border: '1px solid transparent',
    borderRadius: 0,
    boxShadow: '0 1px 1px rgba(0,0,0,0.05)',
    marginBottom: '15px'
  },
  '& .filter-body.filter-editor .save-form input[type="checkbox"]': {
    marginRight: '5px',
    marginTop: 0
  },
  '& .filter-body.filter-editor .save-form .btn + .btn': {
    marginLeft: '10px'
  },
  '& .filter-body.filter-editor .save-form .btn + .checkbox': {
    marginLeft: '15px'
  },
  '& .filter-body.filter-editor .save-form .checkbox label + input': {
    marginLeft: '10px'
  },
  '& .predicate-list li': {
    marginBottom: '5px'
  },
  '& .predicate-list li .error-row': {
    marginTop: '5px'
  },
  '& .predicate-list li .error-row label': {
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '16px',
    color: '#a80000'
  },
  '& .predicate-list li .predicate-row .filter-predicate-property': {
    position: 'relative',
    display: 'inline-block'
  },
  '& .predicate-list li .predicate-row .filter-predicate-property > .btn.btn-default': {
    textAlign: 'right',
    minWidth: '205px'
  },
  '& .predicate-list li .predicate-row .filter-predicate-property > .btn.btn-default > .selected': {
    float: 'left'
  },
  '& .predicate-list li .predicate-row .filter-predicate-property + .predicate-operator': {
    marginLeft: '10px'
  },
  '& .predicate-list li .predicate-row .form-control': {
    display: 'inline-block'
  },
  '& .predicate-list li .predicate-row > * + *': {
    marginLeft: '4px'
  },
  '& .predicate-list li .predicate-row .predicate-property': {
    width: '15em'
  },
  '& .predicate-list li .predicate-row .predicate-operator': {
    width: '15em'
  },
  '& .predicate-list li .predicate-row .predicate-operator + .predicate-value': {
    marginLeft: '10px',
    '& .checkbox-inline, & .checkbox-inline + .checkbox-inline, & .radio-inline, & .radio-inline + .radio-inline': {
      marginLeft: 0,
      marginRight: '10px'
    },
    '& .checkbox-inline:last-child, & .radio-inline:last-child': {
      marginRight: 0
    }
  },
  '& .predicate-list li .predicate-row .predicate-value': {
    display: 'inline-block'
  },
  '& .predicate-list li .predicate-row .predicate-value > input': {
    width: 'inherit'
  },
  '& .predicate-list li .predicate-row .predicate-value + .remove': {
    marginLeft: '16px',
    height: '32px',
    display: 'flex',
    alignItems: 'center'
  },
  '& .predicate-list li .predicate-row .predicate-value button.selector-dropdown-button': {
    backgroundColor: '#fff',
    border: '0'
  },
  '& .predicate-list li .predicate-row .predicate-value .selector.dropdown-menu': {
    marginLeft: '-1px',
    border: '1px solid #ccc'
  },
  '& .predicate-list li .predicate-row .single-operator-column, & .predicate-list li .predicate-row .single-property-column': {
    display: 'inline-block',
    marginTop: '4px'
  },
  '& .predicate-list li .predicate-row .dropdown-submenu': {
    minWidth: '150px',
    position: 'relative'
  },
  '& .predicate-list li .predicate-row .dropdown-submenu li': {
    marginBottom: '0'
  },
  '& .predicate-list li .predicate-row .dropdown-submenu > span': {
    display: 'inline-block'
  },
  '& .predicate-list li .predicate-row .dropdown-submenu:hover > .dropdown-menu': {
    display: 'block',
    visibility: 'visible'
  },
  '& .predicate-list li .predicate-row .dropdown-submenu .spritedimage': {
    marginTop: '2px'
  },
  '& .predicate-list li .predicate-row .btn .caret': {
    marginLeft: '5px'
  },
  '& .filter-header': {
    display: 'inline-block'
  },
  '& .filter-header .filter-button': {
    padding: '7px 10px',
    display: 'inline-block'
  },
  '& .filter-header .filter-button:hover': {
    backgroundColor: '#e5e5e5',
    cursor: 'pointer'
  },
  '& .filter-header .glyphicon-filter': {
    marginRight: '6px'
  },
  '& .filter-header .filterMenu': {
    border: '1px solid #CCCCCC',
    minWidth: '250px',
    padding: '2px'
  },
  '& .filter-header .filterMenu .saved': {
    marginBottom: '2px'
  },
  '& .filter-header .filterMenu .new, & .filter-header .filterMenu .apply': {
    display: 'block',
    color: '#404040',
    padding: '4px 0 4px 20px'
  },
  '& .filter-header .filterMenu .new:hover, & .filter-header .filterMenu .apply:hover, & .filter-header .filterMenu .saved>li:hover': {
    textDecoration: 'none',
    backgroundColor: '#EAECEE'
  },
  '& .filter-header .filterMenu .delete': {
    color: '#404040',
    padding: '4px 4px 4px',
    float: 'right',
    clear: 'right'
  },
  '& .filter-header .filterMenu .apply-header': {
    color: '#929fad',
    padding: '6px 0 4px 9px'
  },
  '& .filter-header .quick': {
    minWidth: '151px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ccc',
    backgroundColor: '#FFFFFF',
    display: 'inline-block'
  },
  '& .filter-header .quick .quick-text': {
    padding: '3px 5px',
    border: 'none'
  },
  '& .filter-header .quick .quick-text:active': {
    border: 'none'
  },
  '& .filter-body .save-form': {
    marginTop: '25px'
  },
  '& .filter-body .save-form h5.checkbox': {
    marginLeft: '15px'
  },
  '& .filter-body .save-form .name': {
    width: '300px'
  },
  '& .grid-toolbar-bar': {
    fontSize: 12
  },
  '& .predicate-list>ul': {
    marginBottom: '10px'
  },
  '& .predicate-list>ul>li.row': {
    marginBottom: '4px'
  },
  '& .predicate-list>ul>li.row>div': {
    paddingLeft: '2px',
    paddingRight: '2px'
  },
  '& .predicate-list>ul>li.row .operator-single': {
    lineHeight: '25px',
    marginLeft: '10px',
    marginBottom: '0'
  },
  '& .predicate-list>ul>li.row .dropdown .dropdown-control .glyphicon-triangle-bottom': {
    float: 'right',
    marginTop: '1px'
  },
  '& .predicate-list>ul>li.row .dropdown .dropdown-menu': {
    border: '1px solid #BBB',
    padding: '3px 5px'
  },
  '& .predicate-list>ul>li.row span.datepicker': {
    padding: '0',
    margin: '0',
    border: '0'
  },
  '& .predicate-list>ul>li.row ul.enum-options>li': {
    whiteSpace: 'nowrap'
  },
  '& .predicate-list>ul>li.row ul.enum-options>li input[type="checkbox"]': {
    marginTop: '0'
  },
  '& .predicate-list a.remove, & .predicate-list a.new': {
    lineHeight: '20px',
    textDecoration: 'none',
    color: '#323130',
    fontSize: 12
  },
  '& ol, & ul': {
    listStyle: 'none',
    paddingLeft: 0
  }
};
exports.filterEditorStyle = filterEditorStyle;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterEditorOverrideStyle = void 0;

const getFilterEditorOverrideStyle = palette => ({
  '& .filter-editor': {
    '& .save-form .checkbox label': {
      display: 'inline-block'
    },
    '& .panel-body': {
      paddingLeft: '32px',
      lineHeight: '19px',
      marginBottom: '28px'
    },
    '& .glyphicon-remove:before': {
      // eslint-disable-next-line no-useless-escape
      content: '"\\E711"'
    },
    '& .glyphicon': {
      display: 'inline-block',
      'font-family': 'MsAds MDL2 Assets',
      'font-size': '14px',
      'font-style': 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale'
    },
    '& .glyphicon.glyphicon-remove': {
      top: 0
    },
    '& .glyphicon.glyphicon-plus': {
      marginRight: 8,
      height: 14,
      width: 14,
      fontFamily: 'MsAds MDL2 Assets',
      color: palette.themePrimary,
      top: 2
    },
    '& .glyphicon-plus:before': {
      content: '"\\E710" !important'
    },
    '& .delivery-status-category-container:first-of-type': {
      float: 'left',
      marginLeft: '20px',
      display: 'inline-block',
      marginTop: 0
    },
    '& .delivery-status-category-container + .delivery-status-category-container': {
      paddingLeft: 20,
      float: 'left'
    },
    '& .predicate-row': {
      alignItems: 'end'
    },
    '& .filter_button': {
      marginTop: 2
    }
  }
});

exports.getFilterEditorOverrideStyle = getFilterEditorOverrideStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegacyFilterBarStyle = void 0;

// Styles for legacy filter bar to make it looks like New UI, no need to use it for new filter bar
const getLegacyFilterBarStyle = ({
  palette
}) => ({
  '& .filter-bar': {
    '& .panel-component': {
      backgroundColor: palette.neutralLighter,
      marginBottom: '0 !important',
      minHeight: 56,
      minWidth: 1000,
      lineHeight: '24px',
      padding: '15px 10px',
      '& .panel-body': {
        padding: 0,
        '& .filter_title_collapsed': {
          marginRight: 35
        },
        '& .filter_row_readonly .humanized': {
          '& .column, & .filter_operator': {
            marginRight: 5
          },
          '& .filterValue': {
            fontWeight: 600
          },
          '& .filterand': {
            display: 'inline-block',
            width: 20
          }
        },
        '& .filter_links': {
          marginLeft: 40,
          '& a': {
            display: 'inline-block',
            textDecoration: 'none',
            '&:nth-child(2n)': {
              fontWeight: 600,
              marginRight: 30,
              color: palette.neutralPrimary
            },
            '&:last-child': {
              marginRight: 0
            }
          }
        },
        '& .filter_title_collapsed, & .filter_row_readonly, & .filter_links': {
          display: 'inline-block'
        }
      }
    }
  }
});

exports.getLegacyFilterBarStyle = getLegacyFilterBarStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSharedStyles = void 0;

var _body = __webpack_require__(39);

var _colGroup = __webpack_require__(41);

var _columns = __webpack_require__(42);

var _footer = __webpack_require__(43);

var _global = __webpack_require__(44);

var _header = __webpack_require__(45);

var _table = __webpack_require__(46);

var variables = _interopRequireWildcard(__webpack_require__(40));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

const GridSharedStyles = {
  getSharedBodyStyles: _body.getSharedBodyStyles,
  getSharedColGroupStyles: _colGroup.getSharedColGroupStyles,
  getSharedColumnsStyles: _columns.getSharedColumnsStyles,
  getSharedFooterStyles: _footer.getSharedFooterStyles,
  getSharedGlobalStyles: _global.getSharedGlobalStyles,
  getSharedHeaderStyles: _header.getSharedHeaderStyles,
  getSharedTableStyles: _table.getSharedTableStyles,
  variables
};
exports.GridSharedStyles = GridSharedStyles;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedBodyStyles = void 0;

var _variables = __webpack_require__(40);

const getSharedBodyStyles = (components, {
  palette
}) => ({
  '& tr.segment-row': {
    fontSize: '12px',
    // Need this so values in primary key will stay 12px
    '& .segment-value': {
      fontSize: '12px'
    }
  },
  // The total rows at the bottom of the table
  '& tr.aggregate-row': {
    '& td': {
      fontSize: '12px !important'
    }
  },
  '& tr.aggregated-row': {
    '& td': {
      fontSize: '12px !important',
      backgroundColor: _variables.totalRowBackgroundColor
    },
    '&:hover': {
      // No hover color changes for aggregated rows.
      '& td': {
        fontSize: '12px !important',
        borderRight: _variables.tableBorder
      }
    }
  },
  '& tr': {
    backgroundColor: '#FFFFFF',
    color: palette.neutralPrimary,
    // hide extra border between header and body, the first filler tr in grid need to be excluded
    '&[data-key]:first-child, &:not([data-key]) + tr[data-key]': {
      '& td': {
        borderTop: 'none'
      }
    },
    '&[data-key]:hover, &.row-selected[data-key], &.row-selected[data-key]:hover': {
      '& td': {
        borderBottom: '1px solid #FFFFFF'
      }
    },
    '&:hover': {
      backgroundColor: palette.neutralLighter
    },
    '&.row-selected': {
      backgroundColor: palette.neutralLight,
      '& td a': {
        color: palette.themeDarker,
        fontWeight: 600
      },
      '&:hover': {
        backgroundColor: palette.neutralQuaternaryAlt
      }
    },
    '&:hover, &.row-selected, &.row-selected:hover': {
      '& td': {
        borderRight: '1px solid #FFFFFF'
      }
    },
    '&.grid-error-row': {
      '& td': {
        '& ul.grid-error-list': {
          listStyle: 'none',
          paddingLeft: 0,
          margin: '0.5em 0',
          color: '#A80000',
          '& .grid-error': {
            paddingRight: 5
          }
        }
      }
    }
  }
});

exports.getSharedBodyStyles = getSharedBodyStyles;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridPaddingComponsation = exports.gridPaddingLeft = exports.tableBorder = exports.totalRowBorderTop = exports.totalRowBackgroundColor = exports.headerRowBorderBottom = exports.headerRowBorderTop = exports.headerRowBackgroundColor = void 0;

var _pagePadding = __webpack_require__(29);

const headerRowBackgroundColor = '#FFFFFF';
exports.headerRowBackgroundColor = headerRowBackgroundColor;
const headerRowBorderTop = '2px solid #81868B';
exports.headerRowBorderTop = headerRowBorderTop;
const headerRowBorderBottom = '2px solid #81868B';
exports.headerRowBorderBottom = headerRowBorderBottom;
const totalRowBackgroundColor = '#FFFFFF';
exports.totalRowBackgroundColor = totalRowBackgroundColor;
const totalRowBorderTop = 'none'; // `1px solid ${palette.neutralLighter}`

exports.totalRowBorderTop = totalRowBorderTop;
const tableBorder = '1px solid #EDEBE9';
exports.tableBorder = tableBorder;
const gridPaddingLeft = _pagePadding.PagePadding.mainSectionLeftPadding;
exports.gridPaddingLeft = gridPaddingLeft;
const gridPaddingComponsation = 0; // These two should add up to 32px

exports.gridPaddingComponsation = gridPaddingComponsation;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedColGroupStyles = void 0;

// use this in '& col'
const getSharedColGroupStyles = () => ({
  width: 120,
  minWidth: 120,
  '&.col-selection': {
    width: 46,
    minWidth: 46
  }
});

exports.getSharedColGroupStyles = getSharedColGroupStyles;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedColumnsStyles = void 0;

var _variables = __webpack_require__(40);

/* eslint-disable max-len */
const getSharedColumnsStyles = () => ({
  '&': {
    padding: '6px 8px',
    verticalAlign: 'middle',
    border: _variables.tableBorder,
    // NOTE: updated from 'palette.neutralLighter' for fit and finish experiments
    fontSize: '12px',
    overflowWrap: 'break-word'
  },
  '&:first-child': {
    paddingLeft: '12px'
  },
  '& span': {
    lineHeight: '16px'
  }
});

exports.getSharedColumnsStyles = getSharedColumnsStyles;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedFooterStyles = void 0;

var _variables = __webpack_require__(40);

const getSharedFooterStyles = () => ({
  '& tr.noborder': {
    '& td': {
      border: 'none',
      paddingLeft: '0px',
      paddingTop: '24px',
      '& .pagination-control': {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px',
        marginBottom: '5px',
        marginLeft: _variables.gridPaddingComponsation,
        '& .form-control.page-size-selector': {
          marginLeft: '5px',
          minWidth: '60px'
        },
        '& .pager': {
          display: 'flex',
          alignItems: 'center',
          marginTop: '0',
          marginBottom: '0',
          marginLeft: '20px',
          '& .nav-button': {
            border: 'none',
            padding: '0',
            minWidth: '20px',
            display: 'flex',
            alignItems: 'center',
            '&.prev': {
              marginRight: '10px',
              '& + .text': {
                display: 'none' // to hide text "Page:"

              }
            },
            '&.next': {
              marginLeft: '10px'
            },
            '&:disabled': {
              backgroundColor: '#fff'
            }
          },
          '& .page-number-input': {
            marginRight: '5px',
            width: '75px'
          }
        }
      }
    }
  }
});

exports.getSharedFooterStyles = getSharedFooterStyles;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedGlobalStyles = void 0;

const getSharedGlobalStyles = (components, {
  palette
}) => ({
  '.bingadsgrid': {
    '& .grid-noresult, & .grid-noresult-empty, & .noresult': {
      color: palette.neutralSecondary,
      fontSize: 26,
      lineHeight: '36px',
      padding: '20px 0 20px 40px'
    }
  },
  '.table-container .glyphicon.glyphicon-triangle-left': {
    fontFamily: '"MsAds MDL2 Assets"'
  },
  '.table-container .glyphicon.glyphicon-triangle-left::before': {
    content: '"\\E76B"',
    color: palette.neutralSecondary
  },
  '.table-container .btn:disabled .glyphicon.glyphicon-triangle-left::before': {
    color: '#BEBBB8'
  },
  '.table-container .glyphicon.glyphicon-triangle-right': {
    fontFamily: '"MsAds MDL2 Assets"'
  },
  '.table-container .glyphicon.glyphicon-triangle-right::before': {
    content: '"\\E76C"',
    color: palette.neutralSecondary
  },
  '.table-container .btn:disabled .glyphicon.glyphicon-triangle-right::before': {
    color: '#BEBBB8'
  },
  '.table-container .glyphicon.glyphicon-triangle-bottom': {
    fontFamily: '"MsAds MDL2 Assets"'
  },
  '.table-container .glyphicon.glyphicon-triangle-bottom::before': {
    content: '"\\E70D"',
    color: palette.neutralSecondary
  },
  '.table-container .btn:disabled .glyphicon.glyphicon-triangle-bottom::before': {
    color: '#BEBBB8'
  }
});

exports.getSharedGlobalStyles = getSharedGlobalStyles;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedHeaderStyles = void 0;

var _variables = __webpack_require__(40);

const getSharedHeaderStyles = (components, {
  palette,
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  '& tr.aggregated-row': {
    '& th': {
      fontSize: '12px'
    }
  },
  '& tr.overall-total-row': {
    '& th': {
      fontWeight: 'normal',
      borderTop: _variables.totalRowBorderTop,
      borderBottom: _variables.tableBorder,
      backgroundColor: _variables.totalRowBackgroundColor
    }
  },
  '& tr': {
    '& th.column-header': {
      borderTop: _variables.headerRowBorderTop,
      borderBottom: _variables.headerRowBorderBottom,
      '& .helpbutton::before': {
        position: 'static'
      },
      '& span.grid-header-text': {
        overflowWrap: 'break-word',
        wordBreak: 'break-word'
      },
      '& span.grid-header-helpId': {
        lineHeight: 1
      }
    },
    '& th': {
      verticalAlign: 'middle',
      fontWeight: '600',
      backgroundColor: _variables.headerRowBackgroundColor,
      color: palette.neutralPrimary,
      border: _variables.tableBorder,
      padding: '6px 8px'
    },
    '& th:first-child': {
      paddingLeft: '12px'
    },
    // we don't want pop first column header to have special padding left
    '&.pop-enabled + tr.pop-enabled th:first-child': {
      paddingLeft: '10px'
    },
    '& th.column-header-sortable': {
      cursor: 'pointer'
    },
    '&.grid-cross-page-select-all': {
      '& th': {
        padding: '0',
        border: 'none'
      }
    },
    '& .glyphicon': {
      fontFamily: iconFontFamily
    },
    '& .glyphicon-arrow-up:before': {
      content: '"\\EE68"'
    },
    '& .glyphicon-arrow-down:before': {
      content: '"\\EE69"'
    },
    // this temporary style for grid POP before we got UI from designer
    '& th span.pop-toggle-icon.clickable': {
      height: '14px',
      width: '14px',
      border: '1px solid transparent',
      display: 'inline-block',
      float: 'none',
      marginTop: '3px',
      '&:hover': {
        border: '1px solid black'
      },
      '& span': {
        display: 'block',
        fontSize: '10px',
        fontFamily: iconFontFamily,
        fontWeight: 'bold',
        '-webkit-font-smoothing': 'antialiased',
        height: '12px',
        lineHeight: '12px',
        textAlign: 'center',
        width: '12px',
        '&.pop-expand:before': {
          content: '"\\E710"',
          color: 'black'
        },
        '&.pop-collapse:before': {
          content: '"\\E738"',
          color: 'black'
        }
      }
    }
  },
  '& tr.pop-enabled th.column-header.pop-column-header > div.column-header-container': {
    display: 'inline-block'
  }
});

exports.getSharedHeaderStyles = getSharedHeaderStyles;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSharedTableStyles = void 0;

const getSharedTableStyles = (components, {
  palette
}) => ({
  '&': {
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none'
  },
  '& .glyphicon': {
    position: 'static'
  },
  '& .iconba': {
    position: 'static'
  },
  '& .grid-disabled': {
    color: palette.neutralSecondaryAlt
  }
});

exports.getSharedTableStyles = getSharedTableStyles;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ThemeFluent", {
  enumerable: true,
  get: function get() {
    return _themeFluent.ThemeFluent;
  }
});
Object.defineProperty(exports, "DarkTheme", {
  enumerable: true,
  get: function get() {
    return _darkTheme.DarkTheme;
  }
});

var _themeFluent = __webpack_require__(48);

var _darkTheme = __webpack_require__(50);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeFluent = void 0;

var _react = __webpack_require__(49);

const ThemeFluent = (0, _react.createTheme)({
  palette: {
    neutralDark: _react.NeutralColors.gray190,
    neutralPrimary: _react.NeutralColors.gray160,
    neutralPrimaryAlt: _react.NeutralColors.gray150,
    neutralSecondary: _react.NeutralColors.gray130,
    neutralSecondaryAlt: _react.NeutralColors.gray110,
    neutralTertiary: _react.NeutralColors.gray90,
    neutralTertiaryAlt: _react.NeutralColors.gray60,
    neutralQuaternary: _react.NeutralColors.gray50,
    neutralQuaternaryAlt: _react.NeutralColors.gray40,
    neutralLight: _react.NeutralColors.gray30,
    neutralLighter: _react.NeutralColors.gray20,
    neutralLighterAlt: _react.NeutralColors.gray10,
    themeDark: _react.CommunicationColors.shade20,
    themeDarker: _react.CommunicationColors.shade30,
    themeDarkAlt: _react.CommunicationColors.shade10,
    themeLight: _react.CommunicationColors.tint20,
    themeLighter: _react.CommunicationColors.tint30,
    themeLighterAlt: _react.CommunicationColors.tint40,
    themePrimary: _react.CommunicationColors.primary,
    themeSecondary: _react.CommunicationColors.tint10,
    themeTertiary: '#71afe5',
    // Shared Colors
    red: _react.SharedColors.red10,
    redDark: _react.SharedColors.red20,
    black: '#000000',
    white: '#ffffff',
    // MS Ads
    globalBackground: '#2f2f2f',
    mainMenuHoverBackground: '#484644'
  },
  effects: {
    roundedCorner2: '2px',
    elevation4: _react.Depths.depth4,
    elevation8: _react.Depths.depth8,
    elevation16: _react.Depths.depth16,
    elevation64: _react.Depths.depth64
  }
});
exports.ThemeFluent = ThemeFluent;
ThemeFluent.iconFontFamily = 'MsAds MDL2 Assets';

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__49__;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkTheme = void 0;

var _react = __webpack_require__(49);

const DarkTheme = (0, _react.createTheme)({
  palette: {
    themePrimary: '#88b0cf',
    themeLighterAlt: '#050708',
    themeLighter: '#161c21',
    themeLight: '#29353e',
    themeTertiary: '#526a7c',
    themeSecondary: '#789bb6',
    themeDarkAlt: '#93b7d3',
    themeDark: '#a2c2da',
    themeDarker: '#b8d1e4',
    neutralLighterAlt: '#201f1e',
    neutralLighter: '#2A2A29',
    neutralLight: '#30302F',
    neutralQuaternaryAlt: '#1c1b1b',
    neutralQuaternary: '#1b1a19',
    neutralTertiaryAlt: '#1a1918',
    neutralTertiary: '#f5f9fd',
    neutralSecondary: '#f6fafe',
    neutralPrimaryAlt: '#f8fbfe',
    neutralPrimary: '#eff6fc',
    neutralDark: '#fbfdfe',
    black: '#fdfeff',
    white: '#201f1e'
  },
  effects: {
    roundedCorner2: '2px',
    elevation4: _react.Depths.depth4,
    elevation8: _react.Depths.depth8,
    elevation16: _react.Depths.depth16,
    elevation64: _react.Depths.depth64
  }
});
exports.DarkTheme = DarkTheme;
DarkTheme.iconFontFamily = 'MsAds MDL2 Assets';

/***/ })
/******/ ]);
});
